import Vue from 'vue';
import VisitorService from '@/services/VisitorService';
import moment from 'moment';

export default {
  namespaced: true,
  state: {
    visitor: null,
  },
  getters: {},
  mutations: {
    SET_VISITOR(state, value) {
      state.visitor = value;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    async getVisitor({ commit, state, dispatch }, id) {
      // eslint-disable-next-line no-underscore-dangle
      await VisitorService.getVisitor(id).then(res => {
        let person = res.data;
        let personNew =  {
          fullName: `${person.firstname} ${person.lastname}`,
          birthDateAndAge: `${moment(person.dob).format('DD/MM/YYYY')} (${moment(new Date()).diff(person.dob, 'years')})`,
          ...person
        };

        commit('SET_VISITOR', personNew);

        return personNew;
      }).catch(err => {
        console.log('error', err);
        Vue.$toast.error('Error getting the additional participant details. Please check your connection and refresh the page', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      });

      return null;
    },
  },
};
